import gql from 'graphql-tag';

export const propertyListQuery = gql`
  query PropertyIntelligenceList(
    $first: Int
    $after: String
    $filter: PropertyListFilterInput
  ) {
    properties(first: $first, after: $after, filter: $filter) {
      items {
        id
        name
        kind
        status
        description
        artworkUrl
        objective
        startDate
        endDate
        plannedUnitCount
        keywords
        updatedAt
      }
      hasMore
      cursor
    }
  }
`;
